import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import { DEFAULT_QUIZ } from '../../constants';

import { getNextQuestionData } from './../../utils/question';
import { generateQuizPreloadPath } from '@lrg/lln-quiz-common/lib/quiz/lib'


const initialState = {
    currentQuestionId: null,
    questionData: null,
    preloadQuestions: null,
};

const slice = createSlice({
    name: 'question',
    initialState,
    reducers: {
        setNextQuestion(state, action) {
            state.currentQuestionId = action.payload.id;
            state.questionData = action.payload;
        },
        setPreloadQuestions(state, action) {
            // console.log('preload questions', action.payload);
            state.preloadQuestions = action.payload;
        }
    }
});

export default slice.reducer;

export function getNextQuestion(data = []) {
    return async () => {
        try {
            const questionData = await getNextQuestionData(data, 'acsf3')
            if (questionData) {
                dispatch(slice.actions.setNextQuestion(questionData));
            }
            return questionData || null;
        } catch (err) {
            console.log(err);
        }
    };
}

export function preloadQuestions(testLevel = DEFAULT_QUIZ, currentQuestionId = "reading-l2q1a" ) {
    return async () => {
        try {
            const preloadQuestionsList = await generateQuizPreloadPath(
                testLevel,
                currentQuestionId,
              )
              dispatch(slice.actions.setPreloadQuestions(preloadQuestionsList));
        } catch (err) {
            console.log(err);
        }
    };
}
